import AuthenticationContext from 'adal-angular/lib/adal.js'

import { authApiService } from '../services/auth-api.service.js'

import adminUser from '../entities/adminUser.js'

const config = {
    tenant: process.env.VUE_APP_TENANT, //'71f69dd0-6588-4c90-acfb-9f2444e27aa6',
    clientId: process.env.VUE_APP_CLIENT_ID, //'1af076e5-061a-4a7f-ad27-e5ab9cfbd75e',
    redirectUri: window.location.origin, // process.env.VUE_APP_REDIRECT_URI, // 'http://localhost:56461',
    //redirectUri: 'https://claimsadminstage.postofficegadget.co.uk',
    cacheLocation: process.env.VUE_APP_CACHE_LOCATION, // 'localStorage'
};

export default {
    authenticationContext: null,
    /**
     * @return {Promise}
     */
    initialize() {
        this.authenticationContext = new AuthenticationContext(config);

        return new Promise((resolve) => {
            if (this.authenticationContext.isCallback(window.location.hash) || window.self !== window.top) {
                // redirect to the location specified in the url params.
                this.authenticationContext.handleWindowCallback();
            }
            else {
                // try pull the user out of local storage
                let user = this.authenticationContext.getCachedUser();
                
                if (user) {
                    adminUser.initialise(user)
                        .finally(() => resolve(adminUser));

                    //  Call app role stuff here, add roles to local storage
                    authApiService.GetRolesTokenForUser()
                        .then((response) => {
                            localStorage.setItem("taurus-admin-roles", response.data);
                        })
                        .catch((error) => {
                            console.log('authApiService.GetRolesTokenForUser-error: ', error)
                        })
                        .finally(() => resolve())
                }
                else {
                    // no user at all - go sign in.
                    this.signIn();
                }

            }
        });
    },
    /**
     * @return {Promise.<String>} A promise that resolves to an ADAL token for resource access
     */
    acquireToken() {
        return new Promise((resolve, reject) => {
            this.authenticationContext.acquireToken(process.env.VUE_APP_CLIENT_ID, (error, token) => {
                if (error || !token) {
                    return reject(error);
                } else {
                    return resolve(token);
                }
            });
        });
    },
    /**
     * Issue an interactive authentication request for the current user and the api resource.
     */
    acquireTokenRedirect() {
        this.authenticationContext.acquireTokenRedirect(process.env.VUE_APP_CLIENT_ID);
    },
    /**
     * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
     */
    isAuthenticated() {
        // getCachedToken will only return a valid, non-expired token.
        if (this.authenticationContext.getCachedToken(config.clientId)) { return true; }
        return false;
    },
    /**
     * @return An ADAL user profile object.
     */
    getUserProfile() {
        return this.authenticationContext.getCachedUser().profile;
    },
    signIn() {
        this.authenticationContext.login();
    },
    signOut() {
        this.authenticationContext.logOut();
    }
}